import React from 'react';
import WalksStats from '../components/WalksStats';
import WalksTable from '../components/WalksTable';
import WalksMap from '../components/WalksMap';
import ScheduleWalkButton from '../components/ScheduleWalkButton';

const WalksPage = () => {
  return (
    <>
      <WalksStats />
      <WalksTable />
      <WalksMap />
      <ScheduleWalkButton />
    </>
  );
};

export default WalksPage;